<template>
  <general-item format="fullscreen">
    <span slot="title">{{ $t('edit.sidebar.in_full_screen') }}</span>
    <span slot="description">{{ $t('edit.sidebar.one_screen_that_cover') }}</span>
  </general-item>
</template>

<script>
import GeneralItem from './GeneralItem';

export default {
  components: {
    GeneralItem,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Fullscreen.vue?0955ce9c
 **/